<modal-payment>

    <!-- Modal -->
    <div class="modal fade" id="{state.elid}" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{state.isPaid ? 'Mark as Unpaid' : 'Record Payment'}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">

                    <div if="{!state.isPaid}">
                        <div class="mb-3">
                            <label for="payment_amount" class="form-label">Payment Amount</label>
                            <div class="input-group">
                                <span class="input-group-text">$</span>
                                <input type="number" step="0.01" class="form-control" id="payment_amount"
                                       placeholder="0.00" value="{state.suggestedAmount}">
                            </div>
                            <div class="form-text">Amount paid to the agency</div>
                        </div>

                        <div class="mb-3">
                            <label for="payment_date" class="form-label">Payment Date</label>
                            <input type="date" class="form-control" id="payment_date">
                        </div>

                        <div class="mb-3">
                            <label for="payment_notes" class="form-label">Notes (optional)</label>
                            <textarea class="form-control" id="payment_notes" rows="2"
                                      placeholder="Check number, transfer reference, etc."></textarea>
                        </div>
                    </div>

                    <div if="{state.isPaid}">
                        <p>Are you sure you want to mark this commission as <strong>unpaid</strong>?</p>
                        <p class="text-muted">This will not delete the payment history.</p>
                    </div>

                    <!-- Payment History -->
                    <div if="{state.payments && state.payments.length > 0}" class="mt-4">
                        <h6>Payment History</h6>
                        <table class="table table-sm table-striped">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th>Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr each="{p in state.payments}">
                                    <td>{fmt.datenice(p.date)}</td>
                                    <td>{formatCurrency(p.amount)}</td>
                                    <td>{p.notes || '-'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn {state.isPaid ? 'btn-warning' : 'btn-success'}" onclick="{onConfirm}">
                        {state.isPaid ? 'Mark Unpaid' : 'Record Payment'}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <script>

        import PubSub from "pubsub-js";
        import {api_get, api_post} from "../../lib/api";
        import Swal from "sweetalert2";
        import currency from "currency.js";
        import dayjs from "dayjs";

        export default {
            state: {
                commissionId: null,
                isPaid: false,
                suggestedAmount: 0,
                payments: []
            },
            onBeforeMount(props, state) {
                this.state.elid = 'modal-payment' + this.genId();
            },
            getModal(){
                return document.getElementById(this.state.elid);
            },
            onMounted() {
                this.events = [];
                this.modal = new bootstrap.Modal(this.getModal(),{});
                const event1 = PubSub.subscribe('modal.payment.show', this.onShow.bind(this));
                const event2 = PubSub.subscribe('modal.payment.hide', this.onHide.bind(this));

                this.events.push(event1, event2);
            },
            onUnmounted() {
                this.events.forEach(e => PubSub.unsubscribe(e));
                this.modal.dispose();
            },
            formatCurrency(value){
                return currency(value).format();
            },
            onShow(msg, data){
                console.log('modal.payment.show', data);

                this.update({
                    commissionId: data.commission.ID,
                    isPaid: data.commission.agency_paid,
                    suggestedAmount: data.commission.commission_agency_total || 0,
                    payments: []
                });

                // Load payment history
                this.loadPayments(data.commission.ID);

                // Set default date to today
                setTimeout(() => {
                    const dateInput = this.$('#payment_date');
                    if(dateInput) {
                        dateInput.value = dayjs().format('YYYY-MM-DD');
                    }
                    const amountInput = this.$('#payment_amount');
                    if(amountInput) {
                        amountInput.value = data.commission.commission_agency_total || 0;
                    }
                }, 50);

                this.modal.show();
            },
            onHide(){
                this.modal.hide();
            },
            loadPayments(commissionId){
                api_get(`commission/payments/${commissionId}`).then((res)=>{
                    if(res.status == 200){
                        this.update({
                            payments: res.data || []
                        });
                    }
                }).catch((err)=>{
                    console.error('Error loading payments:', err);
                });
            },
            onConfirm(){
                const commissionId = this.state.commissionId;

                let payload = {};

                if(!this.state.isPaid) {
                    // Recording a payment
                    const amount = parseFloat(this.$('#payment_amount').value) || 0;
                    const paymentDate = this.$('#payment_date').value;
                    const notes = this.$('#payment_notes').value;

                    if(amount <= 0) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Invalid Amount',
                            text: 'Please enter a valid payment amount.'
                        });
                        return;
                    }

                    payload = {
                        amount: amount,
                        payment_date: paymentDate,
                        notes: notes
                    };
                }

                api_post(`commission/paid/${commissionId}`, payload).then((res)=>{
                    if(res.status == 200 && res.data.success){
                        PubSub.publish('commission.paid.updated', {
                            commissionId: commissionId,
                            agency_paid: res.data.agency_paid
                        });

                        this.onHide();

                        Swal.fire({
                            icon: 'success',
                            title: 'Updated',
                            text: res.data.agency_paid ? 'Payment recorded successfully.' : 'Commission marked as unpaid.',
                            timer: 1500,
                            showConfirmButton: false
                        });
                    }
                }).catch((err)=>{
                    console.error('Error updating paid status:', err);
                    const message = err.response?.data?.message || 'Could not update commission.';
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: message
                    });
                });
            }
        }
    </script>

</modal-payment>
